import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Api from "../../../services/Api";
import queryKeys from "../../../lib/query/queryKeys";

const STATS_URL = "/service/iqevse-csms/api/home/stats";

function fetchStats() {
  return Api.get(STATS_URL);
}

/**
 * Fetches fleet stats from the OpenSearch-backed stats API.
 * Uses React Query so concurrent callers share a single request.
 * Returns { data, isLoading, isError, error, refresh }.
 */
export default function useFleetStats() {
  const queryClient = useQueryClient();

  const {
    data = null,
    isLoading,
    isError,
    error = null,
  } = useQuery({
    queryKey: queryKeys.fleet.stats(),
    queryFn: fetchStats,
    staleTime: 2 * 60 * 1000, // 2 min
  });

  const refresh = useCallback(
    () => queryClient.invalidateQueries({ queryKey: queryKeys.fleet.stats() }),
    [queryClient]
  );

  return { data, isLoading, isError, error, refresh };
}
